import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Router from "next/router";

import { ThemeProvider } from "@mui/material";
import { CloudinaryContext } from "cloudinary-react";
import { Toaster } from "react-hot-toast";

import "../styles/globals.css";
import { theme } from "../styles/theme";
import { AuthProvider } from "../Auth/auth";
import Layout from "../components/Layout/Layout";
import Script from "next/script";

NProgress.configure({
  minimum: 0.3,
  easing: "ease",
  speed: 800,
  showSpinner: false,
});

Router.events.on("routeChangeStart", () => NProgress.start());
Router.events.on("routeChangeComplete", () => NProgress.done());
Router.events.on("routeChangeError", () => NProgress.done());

function MyApp({ Component, pageProps }) {
  return (
    <ThemeProvider theme={theme}>
      <Script
        id="fb-init"
        dangerouslySetInnerHTML={{
          __html: `window.fbAsyncInit = function() {
        FB.init({
          appId            : "526039455287308",
          autoLogAppEvents : true,
          xfbml            : true,
          version          : 'v12.0'
        });
      };`,
        }}
      />
      <Script
        id="fb-jssdk"
        async
        src="https://connect.facebook.net/en_US/sdk.js"
      />
      <Script
        id="google-maps"
        src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDrjEhSquvI7cA7g6rz6lt-i0koIKiAFzY&libraries=places"
      />
      <AuthProvider>
        <CloudinaryContext cloudName="channelgrowth">
          <Layout>
            <Toaster toastOptions={{ style: { maxWidth: "50%" } }} />
            <Component {...pageProps} />
          </Layout>
        </CloudinaryContext>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default MyApp;
